/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_Q3Inputs */

const en_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel anytime?`)
};

const de_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich jederzeit kuendigen?`)
};

const fr_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

const es_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

const it_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

const nl_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

const pl_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

const fi_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

const da_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

const sv_pricing_faq_q3 = /** @type {(inputs: Pricing_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I cancel my subscription anytime?`)
};

/**
* | output |
* | --- |
* | "Can I cancel anytime?" |
*
* @param {Pricing_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_q3 = /** @type {((inputs?: Pricing_Faq_Q3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_Q3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_q3(inputs)
	if (locale === "fr") return fr_pricing_faq_q3(inputs)
	if (locale === "es") return es_pricing_faq_q3(inputs)
	if (locale === "it") return it_pricing_faq_q3(inputs)
	if (locale === "nl") return nl_pricing_faq_q3(inputs)
	if (locale === "pl") return pl_pricing_faq_q3(inputs)
	if (locale === "fi") return fi_pricing_faq_q3(inputs)
	if (locale === "da") return da_pricing_faq_q3(inputs)
	if (locale === "sv") return sv_pricing_faq_q3(inputs)
	return en_pricing_faq_q3(inputs)
});